import React from 'react';
import { cn } from './cn';

const Slider = React.forwardRef(
  ({ className, value = [0], onValueChange, min = 0, max = 100, step = 1, disabled = false, ...props }, ref) => {
    const rawValue = Array.isArray(value) ? value[0] : value;
    const safeValue = Number.isFinite(rawValue) ? rawValue : min;
    const range = Math.max(max - min, 1);
    const percentage = ((safeValue - min) / range) * 100;

    const handleChange = (e) => {
      if (disabled) return;
      const newValue = Number(e.target.value);
      if (onValueChange) {
        onValueChange([newValue]);
      }
    };

    return (
      <input
        ref={ref}
        type="range"
        min={min}
        max={max}
        step={step}
        value={safeValue}
        onChange={handleChange}
        disabled={disabled}
        className={cn(
          'w-full h-2 rounded-lg appearance-none cursor-pointer accent-succession-primary focus:outline-none focus:ring-2 focus:ring-succession-primary/30 disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        style={{
          background: `linear-gradient(to right, var(--succession-primary) 0%, var(--succession-primary) ${percentage}%, var(--succession-bg-secondary) ${percentage}%, var(--succession-bg-secondary) 100%)`,
        }}
        {...props}
      />
    );
  }
);

Slider.displayName = 'Slider';

export { Slider };
